import { api } from "@/lib/api";
import { BlogContent, StudioContentStatus } from "../schema";

const CONTENT_BLOG = "/content-blogs";

export const ContentBlogService = {
  async findAll(filters?: {
    search?: string;
    status?: StudioContentStatus;
    categoryId?: string;
    authorCoachId?: string;
    tagId?: string;
    language?: string;
    page?: number;
    limit?: number;
  }): Promise<{ items: BlogContent[]; pagination: any }> {
    const params = new URLSearchParams();
    if (filters?.search) params.set("search", filters.search);
    if (filters?.status) params.set("status", filters.status);
    if (filters?.categoryId) params.set("categoryId", filters.categoryId);
    if (filters?.authorCoachId)
      params.set("authorCoachId", filters.authorCoachId);
    if (filters?.tagId) params.set("tagId", filters.tagId);
    if (filters?.language) params.set("language", filters.language);
    if (filters?.page) params.set("page", filters.page.toString());
    if (filters?.limit) params.set("limit", filters.limit.toString());

    return api.get<{ items: BlogContent[]; pagination: any }>(
      `${CONTENT_BLOG}?${params.toString()}`,
    );
  },

  async findOne(id: string): Promise<BlogContent> {
    return api.get<BlogContent>(`${CONTENT_BLOG}/${id}`);
  },

  async create(payload: any): Promise<BlogContent> {
    return api.post<BlogContent>(CONTENT_BLOG, payload);
  },

  async update(id: string, payload: any): Promise<BlogContent> {
    return api.patch<BlogContent>(`${CONTENT_BLOG}/${id}`, payload);
  },

  async submitForReview(id: string): Promise<any> {
    return api.post(`${CONTENT_BLOG}/${id}/submit`, {});
  },

  async createVersion(id: string): Promise<{ id: string; version: number }> {
    return api.post(`${CONTENT_BLOG}/${id}/new-version`, {});
  },

  async archive(id: string): Promise<BlogContent> {
    return api.delete<BlogContent>(`${CONTENT_BLOG}/${id}`);
  },

  async restore(id: string): Promise<BlogContent> {
    return api.post<BlogContent>(`${CONTENT_BLOG}/${id}/restore`, {});
  },
};
